const EPIGRAPH_SRC = 'https://cdn.jsdelivr.net/npm/@epigraph/solutions@1';
const EPIGRAPH_ID = 'epigraph-solutions-script';
const EPIGRAPH_STYLES_ID = 'epigraphCustomStyles';

const EPIGRAPH_CUSTOM_CSS = `
.powered-by-epigraph-button,
.powered-by-epigraph-footer,
epg-tool-powered-by-epigraph,
.loading-logo-parent {
    display: none !important;
}
.media {
    width: auto !important;
    max-height: 260px !important;
}
`;

let epigraphLoadingPromise: Promise<void> | null = null;

const ensureEpigraphStyles = () => {
    if (document.getElementById(EPIGRAPH_STYLES_ID)) return;

    const template = document.createElement('template');
    template.id = EPIGRAPH_STYLES_ID;
    template.innerHTML = `<style>${EPIGRAPH_CUSTOM_CSS}</style>`;
    document.body.appendChild(template);
};

export const loadEpigraphAR = (): Promise<void> => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Cannot load Epigraph during SSR'));
    }

    ensureEpigraphStyles();

    if (customElements.get('epigraph-tour')) {
        return Promise.resolve();
    }

    if (epigraphLoadingPromise) {
        return epigraphLoadingPromise;
    }

    epigraphLoadingPromise = new Promise<void>((resolve, reject) => {
        const existing = document.getElementById(
            EPIGRAPH_ID
        ) as HTMLScriptElement | null;

        if (existing) {
            if (existing.dataset.loaded === 'true') {
                resolve();
                return;
            }

            if (existing.dataset.error === 'true') {
                existing.remove();
            } else {
                existing.addEventListener('load', () => resolve(), {
                    once: true,
                });
                existing.addEventListener(
                    'error',
                    () => reject(new Error('Failed to load Epigraph script')),
                    { once: true }
                );
                return;
            }
        }

        const script = document.createElement('script');
        script.type = 'module';
        script.src = EPIGRAPH_SRC;
        script.id = EPIGRAPH_ID;
        script.async = true;
        script.crossOrigin = 'anonymous';

        script.addEventListener(
            'load',
            () => {
                script.dataset.loaded = 'true';
                resolve();
            },
            { once: true }
        );

        script.addEventListener(
            'error',
            () => {
                script.dataset.error = 'true';
                script.remove();
                reject(new Error('Failed to load Epigraph script'));
            },
            { once: true }
        );

        document.body.appendChild(script);
    }).finally(() => {
        epigraphLoadingPromise = null;
    });

    return epigraphLoadingPromise;
};

export const isEpigraphARAvailable = (): boolean => {
    if (typeof window === 'undefined') return false;
    return customElements.get('epigraph-tour') !== undefined;
};
